import { COMPLIFE_LABORATORY } from '@/config/constants';

const historicalArchiveFilters = [
  {
    name: 'productCode',
    label: 'productCode',
    type: 'text',
    whereOperator: '=',
  },
  {
    name: 'productName',
    label: 'productName',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'sampleDescription',
    label: 'sampleDescription',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'customerSampleCode',
    label: 'customerSampleCode',
    type: 'text',
    whereOperator: '=',
  },
  {
    name: 'lot',
    label: 'lot',
    type: 'text',
    whereOperator: '=',
  },
  {
    name: 'lotDate',
    label: 'lotDate',
    type: 'dateDay',
  },
  {
    name: 'department',
    label: 'department',
    type: 'select',
    whereOperator: '=',
    options: Object.keys(COMPLIFE_LABORATORY)
      .map(key => ({ label: `enums.complifeLaboratory.${key}`, value: COMPLIFE_LABORATORY[key] })),
  },
  {
    name: 'acceptanceDate',
    label: 'acceptanceDate',
    type: 'dateRange',
  },
  {
    name: 'reportIssueDate',
    label: 'reportIssueDate',
    type: 'dateRange',
  },
  {
    name: 'reportCode',
    label: 'reportCode',
    type: 'text',
    whereOperator: '=',
  },
  {
    name: 'alreadyDownloaded',
    label: 'alreadyDownloaded',
    type: 'select',
    whereOperator: '=',
    options: [
      { label: 'enums.commons.yes', value: true },
      { label: 'enums.commons.no', value: false },
    ],
  },
];

export default historicalArchiveFilters;
